import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import { AuthService } from './auth.service';
import {environment} from "../../../../environments/environment";
import {QuickLinkService} from "../../../shared/services/quick-link.service";

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(
          private authService: AuthService,
          private quickLinkService: QuickLinkService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let user = this.authService.getAuthFromLocalStorage();
    if(!user) {
        if (!state.url.includes('/activate')) {
            const redirectData = {
                url: state.url,
                expiry: Date.now() + (5 * 60 * 1000) // 5 minutes from now
            };
            sessionStorage.setItem('loginRedirect', JSON.stringify(redirectData));
        }
        this.authService.logout();
        return false;
    }

    if(!environment.enablePermission){
        this.quickLinkService.setLinkAsync(state.url);
        return true;
    }
    let userAuthority = user.authorities;
    let hasAnyAuthority = route.data.hasAnyAuthority;
    let hasAllAuthority = route.data.hasAllAuthority;

    // Enhance user authorities: if user has _WRITE or _APPROVE or _FUND or _DEBIT or _CREATE, they implicitly have _READ
    let enhancedUserAuthority = [...userAuthority];
    userAuthority.forEach(authority => {
        if (authority.endsWith('_WRITE') || authority.endsWith('_APPROVE') || authority.endsWith('_FUND') || authority.endsWith('_DEBIT') || authority.endsWith('_CREATE')) {
            const readAuthority = authority.replace(/_WRITE$|_APPROVE$|_FUND$|_DEBIT$|_CREATE$/, '_READ');
            if (!enhancedUserAuthority.includes(readAuthority)) {
                enhancedUserAuthority.push(readAuthority);
            }
        }
    });

    if(!hasAnyAuthority && !hasAllAuthority) {
        this.quickLinkService.setLinkAsync(state.url);
        return true;
    }

    if(!hasAnyAuthority && hasAllAuthority) {
        let x = hasAllAuthority.every((authority: string) => enhancedUserAuthority.includes(authority));
        if(x) {
            this.quickLinkService.setLinkAsync(state.url);
        }
        return x;
    }else if(hasAnyAuthority && !hasAllAuthority) {
        let x = hasAnyAuthority.some((authority: string) => enhancedUserAuthority.includes(authority));
        if(x) {
            this.quickLinkService.setLinkAsync(state.url);
        }
        return x;
    }else {
        return false;
    }
  }
}
